const Select = require('../../src/js/client/components/Select').default;

exports._select = Select;
